import gql from 'graphql-tag'

export const PARTNERS_FRAGMENT = gql`
  fragment partnersFragment on Element {
    id
    propertyValuesRelation {
      property {
        id
        code
      }
      targetFile {
        id
        url
      }
    }
    propertyValues {
      property {
        id
        code
      }
      id
      value
    }
  }
`
